<template>
  <div>
    <div class="footer">
      <van-cell-group>
        <van-cell v-for="(item,index) in dataList" :key="index" border>
          <template slot="title">
            <img
              :src="item.images"
              class="icon2"
            >
            <a v-if="item.state===1" :href="item.url" class="custom-text">{{ item.text }}</a>
            <div v-else class="custom-text" @click="linkInfo(item.state)">{{ item.text }}</div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      dataList: [
        {
          images: require('../../assets/images/home/pdf.png'),
          text: '500S 血氧心脏健康监测手环说明书',
          url: 'http://admin.guiderhealth.com:8001/500S 血氧心脏健康监测手环说明书.pdf',
          state: 1
        },
        {
          images: require('../../assets/images/home/pdf.png'),
          text: '500H 健康手环说明书',
          url: 'http://admin.guiderhealth.com:8001/500H 健康手环说明书.pdf',
          state: 1
        },
        {
          images: require('../../assets/images/home/pdf.png'),
          text: 'M500远程医疗巡诊箱 操作指南 V2.0',
          url: 'http://admin.guiderhealth.com:8001/M500远程医疗巡诊箱 操作指南 V2.0.pdf',
          state: 1
        },
        {
          images: require('../../assets/images/home/pdf.png'),
          text: '盖德无创血糖 使用说明书',
          url: 'http://admin.guiderhealth.com:8001/盖德无创血糖 使用说明书.pdf',
          state: 1
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '01 盖德500S手环 安装及佩戴操作简介',
          url: 'http://admin.guiderhealth.com:8001/01 盖德500S手环 安装及佩戴操作简介.mp4',
          state: 2
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '02 盖德500S手环 APP下载及安装操作简介',
          url: 'http://admin.guiderhealth.com:8001/02 盖德500S手环 APP下载及安装操作简介.mp4',
          state: 3
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '03 盖德500S手环 APP数据查看及手环使用',
          url: 'http://admin.guiderhealth.com:8001/03 盖德500S手环 APP数据查看及手环使用.mp4',
          state: 4
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '盖德健康500S手环 简介及操作演示（未分解演示操作）',
          url: 'http://admin.guiderhealth.com:8001/盖德健康500S手环 简介及操作演示（未分解演示操作）.mp4',
          state: 5
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: 'M500远程医疗巡诊箱 操作演示',
          url: 'http://admin.guiderhealth.com:8001/M500远程医疗巡诊箱 操作演示.mp4',
          state: 6
        }
      ]
    }
  },
  methods: {
    linkInfo(index) {
      this.$router.push({ path: '/helpContent', query: { id: index }})
    }
  }
}
</script>

<style scoped lang="scss">
.header{
  width:100%;
  height: 194px;
  img{
    width: 100%;
    height:100%;
  }
  .avterbox{
    padding-left:18px;
    position: absolute;
    top: 37px;
    .headerImg{
      width:70px;
      height:70px;
      border-radius: 50%;
      padding:2px;
      background: #f5f5f5;
      margin-right:15px;
    }
  }
}
.cardCar{
  width: 92%;
  height: 73px;
  background: #fff;
  box-shadow: 0 4px 8px 1px #eee;
  position: absolute;
  top:122px;
  left:4%;
  color:#666;
  .icon{
    width: 18px;
    height:16px;
    margin-bottom:10px;
  }
}
.footer{
  margin-top: 10px;
  .van-cell__title{
  display: flex;
  align-items: center;
  .icon2{
  width: 17px;
  height:auto;
  margin-right: 12.5px;
}
}
  .van-cell{
    position: static;
    border-bottom: 10px solid #f5f5f5;
  }
}
.custom-text{
  text-overflow:ellipsis;
  white-space:nowrap;
  overflow:hidden;
}.van-cell__title{
   text-overflow:ellipsis;
   white-space:nowrap;
   overflow:hidden;}
[class*=van-hairline] {
  position: static;
}
</style>
